import type { PropsWithChildren, ReactNode } from 'react'
import { cx } from 'src/utils/cx'

export default function PaperLayout(
  props: PropsWithChildren &
    StyleProps & {
      header?: ReactNode | ((props: { className: string }) => ReactNode)
    },
) {
  const header =
    typeof props.header === 'function'
      ? props.header({ className: 'rounded-t-lg' })
      : props.header

  return (
    <div
      className={cx(
        'mmd:mt-12 mmd:mb-5 mmd:max-w-[min(calc(100vw-2rem),1140px)] mmd:bg-white/90 dark:mmd:bg-black/50 mmd:ring-1 dark:ring-0 ring-black/5 rounded-lg mmd:shadow-lg dark:mmd:![box-shadow:0_-1px_1px_#fff2]',
        props.className,
      )}
      style={props.style}
    >
      {header}
      <div className="py-4 mmd:p-12">{props.children}</div>
    </div>
  )
}
